module.exports = __webpack_public_path__ + "img/6.7f6e292c.png";